export interface FormationOffset {
  x: number;
  y: number;
}

export const FORMATION_SPACING = 60;

/** Offsets from the formation centre for 1-5 ships; larger fleets fall back to a ring. */
export function getFormationOffsets(shipCount: number, spacing: number = FORMATION_SPACING): FormationOffset[] {
  const half = spacing / 2;
  switch (shipCount) {
    case 0:
      return [];
    case 1:
      return [{ x: 0, y: 0 }];
    case 2:
      return [{ x: -half, y: 0 }, { x: half, y: 0 }];
    case 3:
      return [{ x: 0, y: -half }, { x: -half, y: half }, { x: half, y: half }];
    case 4:
      return [
        { x: -half, y: -half }, { x: half, y: -half },
        { x: -half, y: half }, { x: half, y: half }
      ];
    case 5:
      return [
        { x: 0, y: -spacing },
        { x: -spacing, y: 0 },
        { x: 0, y: 0 },
        { x: spacing, y: 0 },
        { x: 0, y: spacing }
      ];
    default:
      return Array.from({ length: shipCount }, (_, i) => {
        const angle = (Math.PI * 2 * i) / shipCount;
        return { x: Math.cos(angle) * spacing, y: Math.sin(angle) * spacing };
      });
  }
}
